<template>
  <div class="flex flex-wrap gap-4">
    <NKbd label="⌘" size="11px" />
    <NKbd label="⌘" size="12px" />
    <NKbd label="⌘" size="13px" />
    <NKbd label="⌘" size="sm" />
    <NKbd label="⌘" size="xl" />
  </div>
</template>
